import service from '@/assets/js/service'
import domain from '@/assets/js/domain'

export const login = params => { return service.post(`/login/v1/getToken`, params) } // 登录

export const getMenu = params => { return service.post(`/auth/v1/getMenu`, params) } // 获取菜单

export const getSignature = `${domain}/login/v1/getSignature` // 签名算法

export const getClientInfoList = params => { return service.post(`/auth/zdkp/v1/yqzlClientInfo/list`, params) } // 查询对接业务系统信息表列表

export const secretKey = params => { return service.post(`/auth/zdkp/v1/vehicleInfo/secretKey`, params) } // 机动车解码-密钥

export const getYqzlPayApproveList = params => { return service.post(`/auth/v1/getYqzlPayApproveList`, params) } // 银行流水审批队列

export const payApprove = params => { return service.post(`/auth/v1/payApprove`, params) } // 银行流水审批



// WEBPACK FOOTER //
// ./src/api/index.js